import React from 'react';

type Size = 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

type Props = {
    columns: Size
    children: React.ReactNode
}

const gridColumnsClasses: Record<Size, string> = {
    '2': 'lg:grid-cols-2',
    '3': 'lg:grid-cols-3',
    '4': 'lg:grid-cols-4',
    '5': 'lg:grid-cols-5',
    '6': 'lg:grid-cols-6',
    '7': 'lg:grid-cols-7',
    '8': 'lg:grid-cols-8',
    '9': 'lg:grid-cols-9',
    '10': 'lg:grid-cols-10',
    '11': 'lg:grid-cols-11',
    '12': 'lg:grid-cols-12',
}

function StatList(props: Props) {
    const {children} = props

    return (
      <dl className={`grid grid-cols-1 gap-4 ${gridColumnsClasses[props.columns]}`}>
          {children}
      </dl>
    );
}

StatList.defaultProps = {
    columns: 3,
}

export default StatList;